'use client';

import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuPortal,
	DropdownMenuTrigger
} from '@pickleballinc/ui/components/ui/dropdown-menu';
import { useEffect, useRef, useState } from 'react';

interface MatchRetireDropdownProps {
	placeholder: string;
	onSelect: (value: string | number) => void;
	options: { value: string | number; label: string; teamMaxRating?: number }[];
	disabled?: boolean;
}

export const MatchRetireDropdown = ({ placeholder, onSelect, options, disabled }: MatchRetireDropdownProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef<HTMLDivElement | null>(null);

	const toggleDropdown = () => {
		if (!disabled) {
			setIsOpen((prev) => !prev);
		}
	};

	const handleSelect = (value: string | number) => {
		onSelect(value);
	};

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	return (
		<div ref={dropdownRef}>
			<DropdownMenu>
				<DropdownMenuTrigger asChild>
					<button
						onClick={toggleDropdown}
						className="flex w-full items-center justify-between rounded-md text-sm font-normal focus:outline-none"
					>
						{placeholder}
						{!disabled && (
							<FontAwesomeIcon
								icon={faAngleDown}
								className={`ml-1 size-4 transition-transform duration-300 md:ml-2 ${isOpen ? 'rotate-180' : 'rotate-0'}`}
							/>
						)}
					</button>
				</DropdownMenuTrigger>

				{!disabled && (
					<DropdownMenuPortal>
						<DropdownMenuContent align="start">
							{options.map((option) => (
								<DropdownMenuItem
									key={option.value}
									onClick={() => handleSelect(option.value)}
									className="cursor-pointer rounded-md px-4 py-2 text-sm font-medium text-gray-900 hover:bg-orange-100"
								>
									{option.label}
								</DropdownMenuItem>
							))}
						</DropdownMenuContent>
					</DropdownMenuPortal>
				)}
			</DropdownMenu>
		</div>
	);
};
